import Vue from "vue";

// Global toasts: `this.$toast.success("Period closed")` from any component.
// Rendered by the CToaster in containers/TheContainer.vue. A second (options) argument is
// accepted for compatibility with existing calls and ignored.
export const toastState = Vue.observable({ items: [] });

let nextId = 1;
const MAX_TOASTS = 20;

function push(color, header, message) {
  toastState.items.push({ id: nextId++, color, header, message: String(message) });
  if (toastState.items.length > MAX_TOASTS) toastState.items.shift();
}

const toast = {
  success: (message) => push("success", "Success", message),
  error: (message) => push("danger", "Error", message),
  warning: (message) => push("warning", "Warning", message),
  info: (message) => push("info", "Info", message),
};

export default {
  install(VueInstance) {
    VueInstance.prototype.$toast = toast;
  },
};
